<template>
	<td class="text-no-wrap text-center">
		<v-row>
			<v-col cols="6">
				<template v-if="editMode">
					<a-number-field-inline
						ref="net"
						v-model="net"
						@change="netChange"
					></a-number-field-inline>
				</template>
				<template v-else>
					{{ toStr(net) }}
				</template>
			</v-col>
			<v-col cols="6">
				<template v-if="editMode">
					<a-number-field-inline
						ref="sum"
						v-model="sum"
						@change="sumChange"
					></a-number-field-inline>
				</template>
				<template v-else>
					{{ toStr(sum) }}
				</template>
			</v-col>
		</v-row>
	</td>
</template>

<script>
	import { toStr, toNum } from '../../../js/common'
	import { c } from '../../../lib/const'
	import aNumberFieldInline from '../../base/ANumberFieldInline.vue'

	export default {
		components: {
			aNumberFieldInline,
		},
		props: {
			sumNet: [ String, Number ],
			editMode: Boolean,
		},
		computed: {},
		data: () => ({
			net: '',
			sum: '',
			tax: c.PERSONAL_TAX,
		}),
		created() {
			this.sum = this.sumNet
			this.net = toStr(toNum(this.sum) * (100 - this.tax) / 100)
		},
		methods: {
			netChange(val, emit) {
				if (emit === undefined) emit = true

				// console.log('netChange', val)

				this.net = val

				this.sum = toNum(val) / (100 - this.tax) * 100
				if (emit) {
					this.sum = toStr(this.sum)
					this.$emit('update:sumNet', this.sum)
				}
				else {
					this.sum = this.sum.toFixed(2)
				}
			},
			sumChange(val, emit) {
				if (emit === undefined) emit = true

				// console.log('sumChange', val)

				this.sum = val
				if (emit) {
					this.$emit('update:sumNet', val)
				}
				else {
					this.sum = this.sum.toFixed(2)
				}

				this.net = toNum(val) * (100 - this.tax) / 100
				if (emit) {
					this.net = toStr(this.net)
					this.$emit('update:netNet', this.net)
				}
				else {
					this.net = this.net.toFixed(2)
				}
			},
			toStr(val) {
				return toStr(val)
			}
		}
	}
</script>

<style scoped>

</style>
